import { render, staticRenderFns } from "./globalLayer.vue?vue&type=template&id=0b96b1e4&scoped=true&"
import script from "./globalLayer.vue?vue&type=script&lang=js&"
export * from "./globalLayer.vue?vue&type=script&lang=js&"
import style0 from "./globalLayer.vue?vue&type=style&index=0&id=0b96b1e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b96b1e4",
  null
  
)

export default component.exports